import { queryOptions, useQuery } from "@tanstack/react-query";
import { apiGet } from "../helpers/request.helpers";
import { convertDateToYYYYMMDD } from "../helpers/time.helpers";
import { SKILLSTER_ORGANIZATION_IDS } from "../helpers/constants";

export type LicenseUpdate = {
  Event: string;
  LicenseCount: number;
  Delta: number;
  ChangedByID: string;
  ChangedByName: string;
  UpdateTime: string;
};

export type SchoolLicenseUpdate = {
  OrganizationID: number;
  OrganizationName: string;
  SchoolID: number;
  SchoolName: string;
  Updates: LicenseUpdate[];
};

export type SchoolLicenseUpdatesResponse = {
  SchoolLicenseUpdates: SchoolLicenseUpdate[];
};

export const schoolLicenseUpdatesQueryOptions = (
  {
    from,
    to,
  }: {
    from?: string;
    to?: string;
  } = { from: "2023-01-01", to: convertDateToYYYYMMDD(new Date()) }
) =>
  queryOptions<SchoolLicenseUpdatesResponse, Error>({
    queryKey: ["school-license-updates", from, to],
    queryFn: async () => {
      const data: SchoolLicenseUpdatesResponse = await apiGet(
        "/school/license-updates",
        {
          from_date: from,
          to_date: to,
        }
      );
      return {
        SchoolLicenseUpdates:
          data.SchoolLicenseUpdates?.filter(
            (d) => !SKILLSTER_ORGANIZATION_IDS.includes(d.OrganizationID)
          ) ?? [],
      };
    },
  });

export function useSchoolLicenseUpdates({
  from,
  to,
}: {
  from?: string;
  to?: string;
} = {}) {
  return useQuery(
    schoolLicenseUpdatesQueryOptions(!!from && !!to ? { from, to } : undefined)
  );
}
